<template>
    <modal class="bindOrderNOModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">绑定预订单</div>
        <div class="modal-body">
            <div class="filter-box">
                <div class="td-box">
                    <div class="lable-name">就餐时间：</div>
                    <el-date-picker class="from-date"
                        v-model="businessHours"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="defaultTime"
                    > </el-date-picker>
                </div>
                <div class="td-box">
                    <div class="lable-name">预订客户：</div>
                    <div class="from-input"><input type="texxt" v-model="CstmName"/></div>
                </div>
                <div class="td-box">
                    <div class="lable-name">手机号：</div>
                    <div class="from-input">
                        <input type="texxt" v-model="Cstm_Mobile"/>
                    </div>
                </div>
                <div class="query-bnt" @click="loadData()">查询</div>
            </div>
            <div class="table-box">
                <el-table class="el-table--scrollable-y" :data="tableList"  highlight-current-row style="width: 100%;" 
                    @current-change="handleCurrentChange"
                    v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}">
                    <el-table-column prop="Eat_PreDate" label="就餐日期" min-width="100" align="center" :formatter="shortDateFormat"></el-table-column> 
                    <el-table-column prop="Eat_PrePhaseName" label="用餐时段" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="Cstm_Name" label="客户姓名" min-width="70" align="center"></el-table-column>
                    <el-table-column prop="Cstm_Mobile" label="手机号" min-width="70" align="center"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["close","confirm"],
    props:{
        isShow:Boolean,
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.loadData();
            }
        }
    },
    data(){
        return {
            tableList:[],
            currentInfo:null,
            /**默认日期范围 */
            defaultTime:[new Date(),new Date()],
            /**选中日期范围 */
            businessHours:[new Date(),new Date()],
            //手机号
            Cstm_Mobile:"",
            //客户
            CstmName:""
        }
    },
    mounted(){
        this.$nextTick(()=>{
            let userInfo = this.$auth.getUserInfo();
            this.businessHours=[userInfo.Rpt_Date,userInfo.Rpt_Date];
            this.loadData();
        });
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        handleCurrentChange(currentRow){
            this.currentInfo=currentRow;
            console.log(currentRow)
        },
        /*时间格式 */
        shortDateFormat(row, column, cellValue){
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd');
        },
        //加载数据
        loadData(){
            let time = JSON.parse(JSON.stringify(this.businessHours));
            const loading = this.$loading({
                text: "获取预订单数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo=this.$auth.getUserInfo(); //获取用户id
            this.$httpAES.post("Bestech.CloudPos.GetReserveOrderInfos", {
                User_ID:userInfo.User_ID,
                Rpt_BDate:new Date(time[0]).Format("yyyy-MM-dd"),//开始日期
                Rpt_EDate:new Date(time[1]).Format("yyyy-MM-dd"), //结束日期
                Cstm_Mobile:this.Cstm_Mobile,
                Cstm_Name:(this.CstmName||"").trim()
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    this.tableList=d.ResponseBody||[];
                    console.log(this.tableList)
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("预订单数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        confirm(){
            if(!this.currentInfo){
                this.$message.warning("请选择要绑定的预订单!");
                return;
            }
            const message=`您确定将就餐日期${(new Date(this.currentInfo.Eat_PreDate)).Format('yyyy-MM-dd')},
            ${this.currentInfo.Eat_PrePhaseName}的订单号${this.currentInfo.Eat_OrderNo}绑定吗?`
            this.$confirm(message, "提示", {
                confirmButtonText: "确定",
                cancelButtonText:"取消",
                callback: (name) => {
                    if(name=='confirm'){
                        this.$emit("confirm",this.currentInfo);
                    }
                },
            }); 
            
        },
    }
}
</script>

<style lang="scss">
@import './bindOrderNOModel.scss'
</style>